import {Config} from './components/types'

export const mojoConfig: Config = {
  Subjective: [
    {
      component: 'TextAreaDataInput',
      name: 'Subjective',
    },
  ],
  Objective: [
    {
      component: 'TextAreaDataInput',
      name: 'Objective',
    },
  ],
  Assessment: [
    {
      component: 'TextAreaDataInput',
      name: 'Assessment',
    },
  ],
  Plan: [
    {
      component: 'TextAreaDataInput',
      name: 'Plan',
    },
  ],
}
